import React from 'react'
import MediaQuery from 'react-responsive'

export const Mobile = (props) => (
  <MediaQuery query="(max-width: 1024px)" {...props} />
)

export const Desktop = (props) => (
  <MediaQuery query="(min-width: 1024px)" {...props} />
)



// WEBPACK FOOTER //
// ./src/components/Responsive/ResponsiveView.js